var _rect, _ellipse, _path, _path2, _path3, _rect2, _rect3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkinCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#fdf4ff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 120,
    rx: 60,
    ry: 75,
    fill: "white",
    stroke: "#a855f7",
    strokeWidth: 2,
    opacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 88 L135 78 L140 88 L135 98Z",
    fill: "#a855f7",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268 100 L273 90 L278 100 L273 110Z",
    fill: "#a855f7",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170 52 L173 45 L176 52 L173 59Z",
    fill: "#f59e0b",
    opacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 215,
    width: 80,
    height: 35,
    rx: 7,
    fill: "white",
    stroke: "#a855f7",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 207,
    width: 60,
    height: 12,
    rx: 4,
    fill: "#a855f7",
    opacity: 0.15
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 272,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#7e22ce"
  }, "Cilt Bakimi")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkinCare);
export default __webpack_public_path__ + "static/media/skin-care.dd28dcd471a2539b48aaabb7701ac393.svg";
export { ForwardRef as ReactComponent };